import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faBuilding,
  faPhone,
  faServer,
  faBoxOpen,
  faUserCheck,
  faEnvelope,
  faFax,
  faSearch,
  faUserLock,
  faCircle,
  faUniversity,
  faIndustry,
  faSatellite,
  faUserShield,
  faChevronUp,
  faChevronDown,
  faColumns,
  faUserClock,
  faUsers,
  faUserTie,
  faAddressCard,
  faBed,
  faSignOutAlt,
  faChevronLeft,
  faChevronRight,
  faCaretDown,
  faSortUp,
  faUser,
  faCheckSquare,
  faSort,
  faArrowUp,
  faArrowDown,
  faEdit,
  faTrash,
  faCheck,
  faTimes,
  faCalendar,
  faBars,
  faHome,
  faMapMarkerAlt,
  faInfoCircle,
  faPaperPlane,
  faRedo,
  faSignInAlt,
  faRupeeSign,
  faEllipsisV,
  faTasks,
  faQuoteLeft,
  faQuoteRight,
  faArrowRight,
  faArrowLeft,
  faDotCircle,
  faCog,
  faFileImport,
  faMagic,
  faPaperclip,
  faTimesCircle,
  faLifeRing,
  faShieldAlt,
  faMobile,
  faAnchor,
  faChargingStation,
  faWater,
  faOilCan,
  faParking,
  faWifi,
  faShower,
  faSwimmingPool,
  faTrashAlt,
  faBath,
  faSun,
  faGasPump,
  faStar,
  faChurch,
  faVenusMars,
  faUpload,
  faUserPlus,
  faComments,
  faBold,
  faThumbsUp,
  faUserEdit,
  faGlobeAsia,
  faSms,
  faUserFriends,
  faFileImage,
  faCamera,
  faEllipsisH,
  faShareSquare,
  faLongArrowAltLeft,
  faRegistered,
  faCheckCircle,
  faCalendarAlt,
  faCommentDots,
  faReply,
  faShareAlt,
  faUserTag,
  faObjectGroup,
  faExclamationTriangle,
  faBookmark,
  faInfo,
  faMapMarkedAlt,
  faEnvelopeOpen,
  faBirthdayCake,
  faMobileAlt,
  faUserCircle,
  faPager,
  faThList,
  faPlus,
  faEye,
  faBell,
} from '@fortawesome/free-solid-svg-icons';
import {
  faTwitterSquare,
  faInstagram,
  faFacebookSquare,
  faLinkedin,
  faGoogle,
} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import VueLazyload from 'vue-lazyload';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
// import plugin
// don't forget to import CSS styles
import 'tiptap-vuetify/dist/main.css';
import 'vuetify/dist/vuetify.min.css';
import '@/scss/variable.scss';

Vue.use(VueLazyload);

library.add(
  faBuilding,
  faPhone,
  faServer,
  faBoxOpen,
  faUserCheck,
  faEnvelope,
  faFax,
  faSearch,
  faUserLock,
  faCircle,
  faUniversity,
  faIndustry,
  faSatellite,
  faUserShield,
  faChevronUp,
  faChevronDown,
  faColumns,
  faUserClock,
  faUsers,
  faUserTie,
  faAddressCard,
  faBed,
  faSignOutAlt,
  faChevronLeft,
  faChevronRight,
  faCaretDown,
  faSortUp,
  faUser,
  faCheckSquare,
  faSort,
  faArrowUp,
  faArrowDown,
  faEdit,
  faTrash,
  faCheck,
  faTimes,
  faCalendar,
  faBars,
  faHome,
  faPhone,
  faEnvelope,
  faMapMarkerAlt,
  faHome,
  faInfoCircle,
  faCommentDots,
  faPaperPlane,
  faRedo,
  faSignInAlt,
  faRupeeSign,
  faEllipsisV,
  faTasks,
  faQuoteLeft,
  faQuoteRight,
  faArrowRight,
  faArrowLeft,
  faDotCircle,
  faCog,
  faFileImport,
  faMagic,
  faPaperclip,
  faTimesCircle,
  faLifeRing,
  faShieldAlt,
  faMobile,
  faAnchor,
  faChargingStation,
  faWater,
  faOilCan,
  faParking,
  faWifi,
  faShower,
  faSwimmingPool,
  faTrashAlt,
  faBath,
  faSun,
  faGasPump,
  faStar,
  faTwitterSquare,
  faInstagram,
  faFacebookSquare,
  faLinkedin,
  faGoogle,
  faChurch,
  faVenusMars,
  faUpload,
  faUserPlus,
  faComments,
  faBold,
  faThumbsUp,
  faUserEdit,
  faGlobeAsia,
  faSms,
  faUserFriends,
  faFileImage,
  faCamera,
  faEllipsisH,
  faShareSquare,
  faLongArrowAltLeft,
  faRegistered,
  faEdit,
  faTrash,
  faCheckCircle,
  faCalendarAlt,
  faEnvelopeOpen,
  faCommentDots,
  faReply,
  faShareAlt,
  faUserTag,
  faObjectGroup,
  faExclamationTriangle,
  faBookmark,
  faInfo,
  faMapMarkedAlt,
  faEnvelopeOpen,
  faBirthdayCake,
  faMobileAlt,
  faUserCircle,
  faPager,
  faThList,
  faPlus,
  faEye,
  faBell,
);

Vue.component('font-awesome-icon', FontAwesomeIcon);

// import VueFire from "vuefire";

Vue.config.productionTip = false;
// Vue.use( VueFire );

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
